import * as z$1 from "zod/v4";
//#region src/schemas/daemon/agent-controller-conversation-capability.ts
const agentControllerConversationExternalImportCapabilitySchema = z$1.enum(["unsupported", "by_ref_id"]);
const agentControllerConversationResumeCapabilitySchema = z$1.enum(["unsupported", "by_ref_id"]);
const agentControllerConversationForkCapabilitySchema = z$1.enum(["unsupported", "by_ref_id"]);
const agentControllerConversationDiscoverCapabilitySchema = z$1.literal("unsupported");
const agentControllerConversationTurnOverrideCapabilitySchema = z$1.enum([
	"unsupported",
	"stateless",
	"persistent"
]);
const agentControllerConversationCapabilitySchema = z$1.strictObject({
	discover: agentControllerConversationDiscoverCapabilitySchema,
	externalImport: agentControllerConversationExternalImportCapabilitySchema,
	fork: agentControllerConversationForkCapabilitySchema,
	resume: agentControllerConversationResumeCapabilitySchema,
	turnOverride: agentControllerConversationTurnOverrideCapabilitySchema
});
const BUILTIN_AGENT_CONTROLLER_CONVERSATION_CAPABILITY_BY_CONTROLLER_ID = {
	antigravity: {
		discover: "unsupported",
		externalImport: "by_ref_id",
		fork: "unsupported",
		resume: "by_ref_id",
		turnOverride: "unsupported"
	},
	codex: {
		discover: "unsupported",
		externalImport: "by_ref_id",
		fork: "by_ref_id",
		resume: "by_ref_id",
		turnOverride: "unsupported"
	},
	"claude-code": {
		discover: "unsupported",
		externalImport: "by_ref_id",
		fork: "by_ref_id",
		resume: "by_ref_id",
		turnOverride: "unsupported"
	},
	cursor: {
		discover: "unsupported",
		externalImport: "by_ref_id",
		fork: "unsupported",
		resume: "by_ref_id",
		turnOverride: "unsupported"
	},
	"grok-build": {
		discover: "unsupported",
		externalImport: "by_ref_id",
		fork: "unsupported",
		resume: "by_ref_id",
		turnOverride: "unsupported"
	},
	opencode: {
		discover: "unsupported",
		externalImport: "unsupported",
		fork: "by_ref_id",
		resume: "by_ref_id",
		turnOverride: "unsupported"
	},
	openclaw: {
		discover: "unsupported",
		externalImport: "unsupported",
		fork: "unsupported",
		resume: "by_ref_id",
		turnOverride: "unsupported"
	}
};
const resolveBuiltinAgentControllerConversationCapability = (builtinControllerId) => {
	const capability = BUILTIN_AGENT_CONTROLLER_CONVERSATION_CAPABILITY_BY_CONTROLLER_ID[builtinControllerId];
	return capability ? { ...capability } : null;
};
//#endregion
export { BUILTIN_AGENT_CONTROLLER_CONVERSATION_CAPABILITY_BY_CONTROLLER_ID, agentControllerConversationCapabilitySchema, agentControllerConversationDiscoverCapabilitySchema, agentControllerConversationExternalImportCapabilitySchema, agentControllerConversationForkCapabilitySchema, agentControllerConversationResumeCapabilitySchema, agentControllerConversationTurnOverrideCapabilitySchema, resolveBuiltinAgentControllerConversationCapability };

//# sourceMappingURL=agent-controller-conversation-capability.js.map